import { useWidgetTitleHeight, Box, useSpaceSize } from "arkh";
import { Image, ImageProps } from "expo-image";

import React from "react";
import { View } from "react-native";
import { graphql, useFragment } from "react-relay";
import { WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$key } from "./__generated__/WidgetEmployeeScheduleIcon_widgetEmployeeSchedule.graphql";

export function WidgetEmployeeScheduleIcon(props: {
  widget: WidgetEmployeeScheduleIcon_widgetEmployeeSchedule$key;
  width: number;
}) {
  const widget = useFragment(
    graphql`
      fragment WidgetEmployeeScheduleIcon_widgetEmployeeSchedule on WidgetEmployeeSchedule {
        provider
      }
    `,
    props.widget
  );

  switch (widget.provider) {
    case "QUINYX":
      return <Logo width={props.width} source={require("./quinyx-logo.svg")} />;
    case "TILTID":
      return <Logo width={props.width} source={require("./tiltid-logo.png")} />;
    case "SOFTONE":
      return (
        <Logo width={props.width} source={require("./softone-logo.png")} />
      );

    default:
      return null;
  }
}

function Logo(props: { source: ImageProps["source"]; width: number }) {
  const height = useWidgetTitleHeight();
  const small = useSpaceSize("xsmall");

  return (
    <View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
      }}
    >
      <Box
        spaceTop="xsmall"
        spaceBottom="xxsmall"
        spaceHorizontal="xsmall"
        style={{
          flexDirection: "row",
          height,
          justifyContent: "space-between",
          width: props.width + small,
        }}
      >
        <Image
          style={{ flex: 1, width: "100%" }}
          contentFit="scale-down"
          contentPosition="left center"
          source={props.source}
        />
      </Box>
    </View>
  );
}
